import { Modules, RouteConstants } from "@valenzinsights/data";

import { IHeaderMenuItems } from "@valenzinsights/react-core";

export const homeMenuItems = (
	hasModuleAccess: (module: string) => boolean,
): IHeaderMenuItems[] => {
	const homeMenus = [
		{
			id: "home-flow",
			title: "",
			disabled: true,
			type: "item",
			children: [
				...(hasModuleAccess(Modules.Home)
					? [
							{
								id: "home",
								title: "Home",
								type: "item",
								url: RouteConstants.Home,
								// icon: Home,
								dropdownIcon: false,
							},
						]
					: []),
				...(hasModuleAccess(Modules.Library)
					? [
							{
								id: "library",
								title: "Library",
								type: "item",
								url: RouteConstants.LibraryWorkspace,
								// icon: LibraryBooks,
								dropdownIcon: false,
							},
						]
					: []),
				...(hasModuleAccess(Modules.Analytics)
					? [
							{
								id: "analytics",
								title: "Analytics",
								type: "item",
								url: RouteConstants.Analytics,
								// icon: StackedBarChart,
								dropdownIcon: false,
							},
						]
					: []),
				...(hasModuleAccess(Modules.MasterData)
					? [
							{
								id: "master-data",
								title: "Master Data",
								type: "item",
								url: RouteConstants.MasterData,
								dropdownIcon: false,
								disabled: false,
								// component: () => {
								// 	return <div onClick={() => console.log("TEST")}> Test </div>;
								// },
							},
						]
					: []),
				...(hasModuleAccess(Modules.UserManagement)
					? [
							{
								id: "user-management",
								title: "User Management",
								url: RouteConstants.UserManagement,
								type: "item",
								dropdownIcon: false,
								disabled: false,
							},
						]
					: []),
			],
		},
	];
	return homeMenus;
};
